import type { ApiDocumentCategory } from '@izimi/api';
import { getExtension, getNameWithoutExtension } from '@izimi/utils';

interface UploadItem {
  creationDate: string;
  file: File;
  fileId: string;
  categories: ApiDocumentCategory[];
  labels: string[];
  isShareable: boolean;
  fileSizeAllowed: boolean;
  fileTypeAllowed: boolean;
  fileNameAllowed: boolean;
}

export type DocumentUploadEntity = ReturnType<typeof createDocumentUploadEntity>;

export const createDocumentUploadEntity = (document: UploadItem) => ({
  uploadSuccess: false,
  uploadStarted: false,
  uploadAborted: false,
  get fileName(): string {
    return this.file.name;
  },
  get fileNameWithoutExtension(): string {
    return getNameWithoutExtension(this.fileName);
  },
  get extension(): string {
    return getExtension(this.fileName);
  },
  get isValid(): boolean {
    return this.fileSizeAllowed && this.fileTypeAllowed && this.fileNameAllowed;
  },
  ...document,
});

export type DocumentUploadEntityKeys = keyof DocumentUploadEntity;
export type DocumentUploadEntityValues = ReturnType<
  typeof createDocumentUploadEntity
>[DocumentUploadEntityKeys];
